import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import reducers from "./userReducer";
// import concerts from "./concerts";
const rootReducer = combineReducers({ i18n: i18nReducer, reducers });
export default rootReducer;
